// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1zMaq","menuBtn":"Header_menuBtn__3R2NI","appName":"Header_appName__1m2hw","categoryLinks":"Header_categoryLinks__1i4Jj"};